/**
 * Maximum number of reports that can be included in a Traffic Light Report
 */
export const MAX_TRAFFIC_LIGHT_REPORTS = 24;

/**
 * Maximum number of files that can be uploaded at once for candidate reports
 */
export const MAX_UPLOAD_FILES = 10; 